import { createReducer, on } from '@ngrx/store';
import { FilterState } from '../../../../models';
import { DataFilterAction } from '../../../actions';
import { FilterInstanceHelper } from '../../../utils';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function filterReducerFactory(filterInstanceHelper: FilterInstanceHelper) {
  const initialState: FilterState = {
    dataToFilter: {},
    fieldDataLoadingState: {},
    filteredDataIds: [],
    fieldsState: null,
    isInitialized: false,
    isEmptyState: false,
  };

  return createReducer(
    initialState,
    on(DataFilterAction.init, (state, action) => {
      const fieldDataLoadingState = {};

      Object.entries(action.loadingState).forEach(([key, value]) => {
        if (value) {
          fieldDataLoadingState[key] = true;
        }
      });

      return {
        ...state,
        fieldDataLoadingState
      };
    }),
    on(DataFilterAction.definitionStateBuilt, (state, action) => {
      let isEmptyState = filterInstanceHelper.isEmptyState(state, action.definitionState);

      const filterDefinitionState = filterInstanceHelper.mergeDefinitions(action.definitionState, state.fieldsState);
      const handled = filterInstanceHelper.handleDataAndDefinitionChange(
        state,
        filterDefinitionState,
        action.dataDictionary
      );

      return {
        ...handled,
        fieldDataLoadingState: state.fieldDataLoadingState,
        fieldsState: filterDefinitionState,
        dataToFilter: action.dataDictionary,
        isEmptyState,
        arePreviouslyAllDisplayed: state.filteredDataIds.length === Object.keys(state.dataToFilter).length,
      };
    }),
    on(DataFilterAction.fieldDataLoaded, (state, action) => {
      const fieldDataLoadingState = {
        ...state.fieldDataLoadingState
      };
      delete fieldDataLoadingState[action.fieldId];
      return {
        ...state,
        fieldDataLoadingState: fieldDataLoadingState,
      };
    }),
    on(DataFilterAction.toggleOptions, (state, action) =>
      filterInstanceHelper.toggleOptionsInState(action.optionsData, state)
    ),
    on(DataFilterAction.forceCalculation, (state, _) => {
      if (!state.isInitialized) {
        return state;
      }

      const filteredDataIds = filterInstanceHelper.calculateFilteredDataIdsForFields(
        Object.values(state.fieldsState),
        state.dataToFilter,
        true
      );

      return {
        ...state,
        previousDefinitionState: null,
        filteredDataIds,
      };
    }),
    on(DataFilterAction.selectOptions, (state, action) =>
      filterInstanceHelper.changeSelectionState(action.optionsData, state, true)
    ),
    on(DataFilterAction.unSelectOptions, (state, action) =>
      filterInstanceHelper.changeSelectionState(action.optionsData, state, false)
    ),
    on(DataFilterAction.setOptions, (state, action) =>
      filterInstanceHelper.setOptionsInState(action.optionsData, state)
    ),
    on(DataFilterAction.reset, (state) => {
      if (!state.fieldsState) {
        return state;
      }

      return filterInstanceHelper.resetFields(Object.values(state.fieldsState), state);
    }),
    on(DataFilterAction.resetFields, (state, action) => {
      return filterInstanceHelper.resetFields(
        action.fieldIds.map((fieldId) => state.fieldsState[fieldId]),
        state
      );
    })
  );
}
